import { formatDate } from '../../utils';

const transformSolutions = ({ results = [] }) =>
  results.map(({ id, status, displayName, createdAt, description }) => ({
    id,
    status,
    name: displayName,
    description,
    createdOn: formatDate(createdAt),
  }));

export default transformSolutions;
